import React, { useState, useEffect } from "react";
// Importando os componentes PADRÃO do Material UI
import { Box, Container, Grid, Link, Paper, IconButton, Autocomplete, TextField, Snackbar, Alert, Avatar } from "@mui/material";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import api from "../services/api";

import logoImage from "../assets/images/logo-white.png";
import SearchIcon from "@mui/icons-material/Search";
import LocationOnIcon from "@mui/icons-material/LocationOn";

// Lista de cidades da Região Metropolitana de BH
const bhCities = [
    "Belo Horizonte", "Betim", "Contagem", "Nova Lima", "Santa Luzia",
    "Sabará", "Ribeirão das Neves", "Vespasiano", "Ibirité", "Caeté",
    "Brumadinho", "Lagoa Santa", "Pedro Leopoldo", "Raposos", "Rio Acima",
    "São José da Lapa", "Sarzedo", "Juatuba", "Mateus Leme", "Florestal",
    "Rio Manso", "Itatiaiuçu", "Itaguara", "Baldim", "Jaboticatubas",
    "Taquaraçu de Minas", "Nova União", "Confins", "São Joaquim de Bicas",
    "Igarapé", "Mário Campos", "Capim Branco", "Matozinhos"
];

// Define a URL do Painel dinamicamente baseada no ambiente
const APP_URL = process.env.REACT_APP_PANEL_URL || (process.env.NODE_ENV === 'production' 
  ? "https://app.djparafestas.com.br" 
  : "http://localhost:3000");

function MenuBar() {
    const location = useLocation();
    const navigate = useNavigate();
    const [busca, setBusca] = useState("");
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [user, setUser] = useState(null);
    const [isClient, setIsClient] = useState(false);
    const [clientHash, setClientHash] = useState(null);
    const [clientOptions, setClientOptions] = useState("");

    // Verifica autenticação via Cookie (Igual HeroSection)
    useEffect(() => {
        const getCookie = (name) => {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        };

        const token = getCookie('dj_auth_token');
        const clientToken = localStorage.getItem('client_token');
        const storedHash = localStorage.getItem('client_hash');
        const storedOptions = localStorage.getItem('client_options');

        if (token) {
            api.get('me', {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then((response) => {
                const userData = response.data.data ? response.data.data : response.data;
                setUser(userData);
            })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    document.cookie = "dj_auth_token=; path=/; max-age=0";
                    document.cookie = "dj_auth_token=; path=/; domain=.djparafestas.com.br; max-age=0";
                }
                setUser(null);
            });
        } else if (clientToken) {
            setIsClient(true);
            if (storedHash) setClientHash(storedHash);
            if (storedOptions) setClientOptions(storedOptions);
        }
    }, []);

    const handleClientLogout = () => {
        localStorage.removeItem('client_token');
        localStorage.removeItem('client_hash');
        localStorage.removeItem('client_options');
        setIsClient(false);
        navigate('/');
        window.location.reload();
    };

    // Sincroniza o input com a URL (caso o usuário recarregue a página já com filtro)
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const cidade = params.get("cidade");
        if (cidade) setBusca(cidade);
    }, [location.search]);

    const handleSearch = () => {
        const termo = busca.trim();
        
        if (!termo) {
             navigate(`/artistas/`);
             return;
        }

        // Validação: Verifica se a cidade está na lista (case insensitive)
        const cidadeValida = bhCities.some(city => city.toLowerCase() === termo.toLowerCase());

        if (!cidadeValida) {
            setOpenSnackbar(true);
            return;
        }

        navigate(`/artistas/?cidade=${encodeURIComponent(busca)}`);
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    return (
            <Box
              sx={{
                position: "sticky",
                top: 0,
                left: 0,
                zIndex: 1100,
                width: "100%",
                height: "auto",
                background: "linear-gradient(135deg, #8A2BE2 0%, #183cdd 100%)", // Gradiente Roxo
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                overflow: "hidden",
                pt: 2,
                pb: 2,
                transition: "all 0.3s ease-in-out",
                boxShadow: "0 4px 20px rgba(0,0,0,0.1)"
              }}
            >
                 <Container
                   maxWidth={false}
                   sx={{
                     mx: "auto",
                     maxWidth:
                     {
                       xs: "90%",
                       lg: "90%",
                       "@media (min-width: 2000px)": {
                         maxWidth: "70%"
                       }
                     }
                   }}
                 >

                <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
                    <Grid item xs={6} md="auto" sx={{ width: { md: "300px" }, textAlign: "left" }}>
                        {/* Logo */}
                        <Link component={RouterLink} to="/" underline="none">
                            <Box component="img" src={logoImage} alt="Logo" sx={{ width: { xs: "110px", md: "150px" }, cursor: "pointer" }} />
                        </Link>
                    </Grid>

                    {/* Menu (Igual Home) - Ordem alterada: Direita no Mobile, Extrema Direita no Desktop */}
                    <Grid item xs={6} md="auto" sx={{ width: { md: "300px" }, order: { xs: 2, md: 3 }, display: "flex", alignItems: "center", justifyContent: "flex-end", gap: { xs: 1, md: 2 } }}>
                        {isClient ? (
                            <>
                                <Link
                                    component={RouterLink}
                                    to={clientHash ? `/track-order/${clientHash}${clientOptions || ''}` : "/meus-pedidos"}
                                    underline="none"
                                    sx={{
                                        color: "#fff",
                                        mx: { xs: 0.5, md: 2 },
                                        fontSize: { xs: "0.8rem", md: "1rem" },
                                        fontWeight: 600,
                                        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                                        "&:hover": { color: "#d1c4e9", transition: "0.3s" },
                                    }}
                                >
                                    Painel
                                </Link>
                                <Link
                                    component="button"
                                    onClick={handleClientLogout}
                                    underline="none"
                                    sx={{
                                        color: "#fff",
                                        mx: { xs: 0.5, md: 2 },
                                        fontSize: { xs: "0.8rem", md: "1rem" },
                                        fontWeight: 600,
                                        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                                        "&:hover": { color: "#d1c4e9", transition: "0.3s" },
                                        background: 'none',
                                        border: 'none',
                                        padding: 0,
                                        cursor: 'pointer',
                                    }}
                                >
                                    Sair
                                </Link>
                            </>
                        ) : (
                        <>
                        <Link
                            href={user ? `${APP_URL}/dashboard` : `${APP_URL}/auth/register`}
                            underline="none"
                            sx={{
                                color: "#fff",
                                mx: { xs: 0.5, md: 2 },
                                fontSize: { xs: "0.8rem", md: "1rem" },
                                fontWeight: 600,
                                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                                "&:hover": { color: "#d1c4e9", transition: "0.3s" },
                            }}
                        >
                            {user ? "Painel do Artista" : "Cadastro de Artista"}
                        </Link>
                        
                        {user ? (
                            <Link
                                href={`${APP_URL}/profile`}
                                underline="none"
                            >
                                <Avatar
                                    alt={user.name || user.artist_name}
                                    src={user.profile_image || (user.profileMedia ? user.profileMedia.url : null)}
                                    sx={{ 
                                        width: 36, 
                                        height: 36, 
                                        border: "2px solid #fff",
                                        cursor: "pointer",
                                        transition: "0.2s",
                                        "&:hover": { borderColor: "#d1c4e9" }
                                    }}
                                />
                            </Link>
                        ) : (
                            <Link
                                href={APP_URL}
                                underline="none"
                                sx={{
                                    color: "#fff",
                                    mx: { xs: 0.5, md: 2 },
                                    fontSize: { xs: "0.8rem", md: "1rem" },
                                    fontWeight: 600,
                                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                                    "&:hover": { color: "#d1c4e9", transition: "0.3s" },
                                }}
                            >
                                Entrar
                            </Link>
                        )}
                        </>
                        )}
                    </Grid>

                    {/* Filtro de Cidade (Abaixo do menu no Mobile, Centro no Desktop) */}
                    <Grid item xs={12} md sx={{ order: { xs: 3, md: 2 }, flexGrow: 1 }}>
                            <Paper
                                component="form"
                                elevation={2}
                                sx={{
                                    p: "2px 4px",
                                    display: "flex",
                                    alignItems: "center",
                                    width: { xs: "100%", md: "70%" },
                                    maxWidth: "100%",
                                    mx: "auto",
                                    borderRadius: "8px",
                                    height: "45px",
                                    backgroundColor: "#fff"
                                }}
                            >
                                <LocationOnIcon sx={{ color: "action.active", ml: 1, mr: 1 }} />
                                <Autocomplete
                                    freeSolo
                                    options={bhCities}
                                    value={busca}
                                    onInputChange={(event, newInputValue) => {
                                        setBusca(newInputValue);
                                    }}
                                    sx={{ ml: 1, flex: 1 }}
                                    renderInput={(params) => (
                                        <TextField 
                                            {...params} 
                                            placeholder="Em qual cidade?" 
                                            fullWidth
                                            variant="standard"
                                            InputProps={{ 
                                                ...params.InputProps, 
                                                disableUnderline: true,
                                                "aria-label": "filtrar por cidade"
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    e.preventDefault();
                                                    handleSearch();
                                                }
                                            }}
                                        />
                                    )}
                                />
                                <IconButton type="button" sx={{ p: "10px" }} aria-label="search" onClick={handleSearch}>
                                    <SearchIcon />
                                </IconButton>
                            </Paper>
                    </Grid>
                </Grid>

                {/* Snackbar de Aviso */}
                <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                    <Alert onClose={handleCloseSnackbar} severity="warning" sx={{ width: '100%' }}>
                        Ainda não estamos trabalhando nessa localidade.
                    </Alert>
                </Snackbar>
            </Container>
        </Box>
    );
}

export default MenuBar;